export function radioClassNames(labelColor?: 'navy' | 'grey') {
  return {
    base: 'outline-1 outline-grey-20 rounded p-2 w-full',
    label: labelColor === 'navy' ? 'text-navy w-full' : 'text-grey w-full',
  }
}
